import styled, { css } from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;

    li {
        font-family: 'Inter', sans-serif;
        font-size: 0.78rem;
        margin-left: 2vw;
        margin-top: 0.8vh;
        margin-bottom: 0.8vh;
        color: #777777;
    }
`

export const Phrase = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 0.78rem;
    margin-left: 1.5vw;
    margin-top: 0.8vh;
    margin-bottom: 0.8vh;
    color: #777777;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 62vw;
    margin-top: 2.8vh;
    margin-left: 1.5vw;
    margin-right: 1vw;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const ProgressBarDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2.8vh;
    margin-left: 0.1vw;
    margin-right: 0.1vw;
    margin-bottom: 3vh;

    .active{
        background-color: #0090D3;
    }
`

export const ProgressBarCircle = styled.div`
    width: 1vw;
    height: 1vw;
    border-radius: 2vw;
    background-color: #C4C4C4;
`

export const ProgressBarLine = styled.div`
    width: 29vw;
    height: 0.5vh;
    background-color: #C4C4C4;
`

export const ButtonsDiv = styled.div`
    display: flex;
    margin-top: 1vh;
    align-items: center;
    margin-left: 39vw;
`

export const CancelButton = styled.button`
    width: 8vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    border: 0;
    cursor: pointer;
`

export const PreviousButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 6.5vw;
    height: 5.8vh;
    background-color: #fff;
    color: #0090D3;
    border: solid #0090D3 1px;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: pointer;
`

export const PreviousButtonImage = styled.img`
    margin-left: 1vw;   
    width: 0.9vw;
`

export const PreviousButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`

export const NextButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 8vw;
    height: 5.8vh;
    background-color: #0090D3;
    color: #fff;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: pointer;
`

export const NextButtonImage = styled.img`
    margin-left: 1vw;   
    width: 0.9vw;
`

export const NextButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`

export const DisabledNextButtonDiv = styled.div`
    display: flex;
    align-items: center;
    width: 8vw;
    height: 5.8vh;
    background-color: #ebebeb;
    color: #c4c4c4;
    margin-top: 2.5vh;
    margin-bottom: 2.5vh;
    margin-left: 1vw;
    border-radius: 3vw;
    cursor: not-allowed;
`

export const DisabledNextButtonImage = styled.img`
    margin-left: 1vw;   
    width: 0.9vw;
`

export const DisabledNextButtonText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 1vw;
    font-weight: 700;
    margin-left: 0.6vw;
`
